import { render, staticRenderFns } from "./TextareaAutosize.vue?vue&type=template&id=4ad2a4c6&"
import script from "./TextareaAutosize.vue?vue&type=script&lang=js&"
export * from "./TextareaAutosize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4ad2a4c6', component.options)
    } else {
      api.reload('4ad2a4c6', component.options)
    }
    module.hot.accept("./TextareaAutosize.vue?vue&type=template&id=4ad2a4c6&", function () {
      api.rerender('4ad2a4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/TextareaAutosize.vue"
export default component.exports